import { createContext, useReducer, useContext } from 'react'
import { INIT_STATE , reducer} from './reducers/auth-user-reducer'

export const AuthUserContext = createContext({})

export const AuthUserContextProvider = ({ children }) => {
    const [authUser, authUserDispatch] = useReducer( reducer, INIT_STATE);
    
    return (
        <AuthUserContext.Provider
            value={{ authUser, authUserDispatch}}
        >
            {children}
        </AuthUserContext.Provider>
    )
}

export const useAuthUser = ()=> useContext(AuthUserContext)